import BaseEntity from './base/BaseEntity.model';

export default class ComponentImportConfig extends BaseEntity {
    public properties!: ComponentImportConfigProp[];
    constructor(public componentName?: string) {
        super();
        this.init();
    }
    init(){
        this.properties = [];
    }

}


export class ComponentImportConfigProp extends BaseEntity {
    public componentImportConfigId!: number | undefined;
    public profileAttributeId!: number | undefined;
    public profileAttributeId2!: number | undefined;
    public isStaticValue!: boolean;
    public staticValue!: string | undefined;
    public tipoTramiteComponentImportConfigId!: number | undefined;
    public editMode: boolean | undefined = true;
    public label : string | undefined = String();

    constructor(public name?: string, public type?: string, public required?: boolean, public profileAttributeName?: string) {
        super();
        this.init();
    }
    init(){
        this.componentImportConfigId = undefined;
        this.profileAttributeId = undefined;
        this.isStaticValue = false;
        this.staticValue = undefined;
        this.tipoTramiteComponentImportConfigId = undefined;
        this.profileAttributeId2 = undefined;
    }
}